import { clanLabelFrom } from './displayName';
import { CDL_2026_MODES } from './modes';

// Shared match-card display helpers — extracted from MatchCardLive.tsx
// (Lisa, 2026-07-24) so VetoBoard (components/VetoBoard.tsx) can use the
// same formatting as the rest of the match card without duplicating it.
// Pure extraction: logic unchanged from the original module-local
// functions.

// Clan display-name preservation (Lisa, 2026-07-13): prefers the match
// row's denormalized clan1DisplayName/clan2DisplayName (stamped at
// match-create time from clan METADATA — the single authority for a
// clan's original-casing name) over stripping the canonical
// CLAN#UPPER_UNDERSCORE id, which cannot round-trip special characters
// (e.g. "$kare" → "KARE"). `id` is matched against clan1Id/clan2Id to pick
// the right side; anything else (or a match row with no stamp — legacy,
// pre-fix) falls back to the old canonical-strip behaviour untouched.
export function clanLabel(
  id: string | undefined,
  clan1Id: string, clan2Id: string,
  clan1DisplayName?: string, clan2DisplayName?: string,
): string {
  const displayName = id === clan1Id ? clan1DisplayName : id === clan2Id ? clan2DisplayName : undefined;
  return clanLabelFrom(displayName, id);
}

export const MODE_LABEL = (key: string) =>
  CDL_2026_MODES.find(m => m.key === key)?.shortLabel ?? key.toUpperCase();
